class ValuesPFD {
  constructor(valor, unit, secuencia, estado) {
    this.valor = valor;
    this.unit = unit;
    this.secuencia = secuencia;
    this.estado = estado;
  }

  setValor(valor) {
    this.valor = valor;
    return this;
  }

  setUnit(unit) {
    this.unit = unit;
    return this;
  }

  setSecuencia(secuencia) {
    this.secuencia = secuencia;
    return this;
  }

  setEstado(estado) {
    this.estado = estado;
    return this;
  }
}

export class GlobalCorrientesPDF {
  // Mensaje statico para cuando no tenemos datos
  static NO_DATA = "NO OPERANDO";
  constructor(data) {
    this.corriente1 = new ValuesPFD()
      .setValor(data[0].valor)
      .setUnit(data[0].unit)
      .setSecuencia(data[0].secuencia)
      .setEstado(data[0].estado);

    this.corriente2 = new ValuesPFD()
      .setValor(data[1].valor)
      .setUnit(data[1].unit)
      .setSecuencia(data[1].secuencia)
      .setEstado(data[1].estado);

    this.corriente3 = new ValuesPFD()
      .setValor(data[2].valor)
      .setUnit(data[2].unit)
      .setSecuencia(data[2].secuencia)
      .setEstado(data[2].estado);

    this.corriente4 = new ValuesPFD()
      .setValor(data[3].valor)
      .setUnit(data[3].unit)
      .setSecuencia(data[3].secuencia)
      .setEstado(data[3].estado);

    this.corriente5 = new ValuesPFD()
      .setValor(data[4].valor)
      .setUnit(data[4].unit)
      .setSecuencia(data[4].secuencia)
      .setEstado(data[4].estado);

    this.corriente6 = new ValuesPFD()
      .setValor(data[5].valor)
      .setUnit(data[5].unit)
      .setSecuencia(data[5].secuencia)
      .setEstado(data[5].estado);

    this.corriente7 = new ValuesPFD()
      .setValor(data[6].valor)
      .setUnit(data[6].unit)
      .setSecuencia(data[6].secuencia)
      .setEstado(data[6].estado);

    this.corriente8 = new ValuesPFD()
      .setValor(data[7].valor)
      .setUnit(data[7].unit)
      .setSecuencia(data[7].secuencia)
      .setEstado(data[7].estado);

    this.corriente9 = new ValuesPFD()
      .setValor(data[8].valor)
      .setUnit(data[8].unit)
      .setSecuencia(data[8].secuencia)
      .setEstado(data[8].estado);

    this.corriente10 = new ValuesPFD()
      .setValor(data[9].valor)
      .setUnit(data[9].unit)
      .setSecuencia(data[9].secuencia)
      .setEstado(data[9].estado);

    this.corriente11 = new ValuesPFD()
      .setValor(data[10].valor)
      .setUnit(data[10].unit)
      .setSecuencia(data[10].secuencia)
      .setEstado(data[10].estado);

    this.corriente12 = new ValuesPFD()
      .setValor(data[11].valor)
      .setUnit(data[11].unit)
      .setSecuencia(data[11].secuencia)
      .setEstado(data[11].estado);

    this.corriente13 = new ValuesPFD()
      .setValor(data[12].valor)
      .setUnit(data[12].unit)
      .setSecuencia(data[12].secuencia)
      .setEstado(data[12].estado);

    this.corriente14 = new ValuesPFD()
      .setValor(data[13].valor)
      .setUnit(data[13].unit)
      .setSecuencia(data[13].secuencia)
      .setEstado(data[13].estado);

    this.corriente15 = new ValuesPFD()
      .setValor(data[14].valor)
      .setUnit(data[14].unit)
      .setSecuencia(data[14].secuencia)
      .setEstado(data[14].estado);

    this.corriente16 = new ValuesPFD()
      .setValor(data[15].valor)
      .setUnit(data[15].unit)
      .setSecuencia(data[15].secuencia)
      .setEstado(data[15].estado);

    this.corriente17 = new ValuesPFD()
      .setValor(data[16].valor)
      .setUnit(data[16].unit)
      .setSecuencia(data[16].secuencia)
      .setEstado(data[16].estado);
  }

  getValueCorriente(secuencia) {
    switch (secuencia) {
      case 1:
        if (this.corriente1.valor === null || this.corriente1.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente1.valor) +
            " " +
            this.elevarATres(this.corriente1.unit)
          );
        }

      case 2:
        if (this.corriente2.valor === null || this.corriente2.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente2.valor) +
            " " +
            this.elevarATres(this.corriente2.unit)
          );
        }

      case 3:
        if (this.corriente3.valor === null || this.corriente3.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente3.valor) +
            " " +
            this.elevarATres(this.corriente3.unit)
          );
        }

      case 4:
        if (this.corriente4.valor === null || this.corriente4.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente4.valor) +
            " " +
            this.elevarATres(this.corriente4.unit)
          );
        }

      case 5:
        if (this.corriente5.valor === null || this.corriente5.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente5.valor) +
            " " +
            this.elevarATres(this.corriente5.unit)
          );
        }

      case 6:
        if (this.corriente6.valor === null || this.corriente6.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente6.valor) +
            " " +
            this.elevarATres(this.corriente6.unit)
          );
        }

      case 7:
        if (this.corriente7.valor === null || this.corriente7.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente7.valor) +
            " " +
            this.elevarATres(this.corriente7.unit)
          );
        }

      case 8:
        if (this.corriente8.valor === null || this.corriente8.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente8.valor) +
            " " +
            this.elevarATres(this.corriente8.unit)
          );
        }

      case 9:
        if (this.corriente9.valor === null || this.corriente9.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente9.valor) +
            " " +
            this.elevarATres(this.corriente9.unit)
          );
        }

      case 10:
        if (this.corriente10.valor === null || this.corriente10.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente10.valor) +
            " " +
            this.elevarATres(this.corriente10.unit)
          );
        }

      case 11:
        if (this.corriente11.valor === null || this.corriente11.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente11.valor) +
            " " +
            this.elevarATres(this.corriente11.unit)
          );
        }

      case 12:
        if (this.corriente12.valor === null || this.corriente12.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente12.valor) +
            " " +
            this.elevarATres(this.corriente12.unit)
          );
        }

      case 13:
        if (this.corriente13.valor === null || this.corriente13.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente13.valor) +
            " " +
            this.elevarATres(this.corriente13.unit)
          );
        }

      case 14:
        if (this.corriente14.valor === null || this.corriente14.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente14.valor) +
            " " +
            this.elevarATres(this.corriente14.unit)
          );
        }

      case 15:
        if (this.corriente15.valor === null || this.corriente15.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente15.valor) +
            " " +
            this.elevarATres(this.corriente15.unit)
          );
        }

      case 16:
        if (this.corriente16.valor === null || this.corriente16.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente16.valor) +
            " " +
            this.elevarATres(this.corriente16.unit)
          );
        }

      case 17:
        if (this.corriente17.valor === null || this.corriente17.estado === 0) {
          return GlobalCorrientesPDF.NO_DATA;
        } else {
          return (
            this.toFixedValue(this.corriente17.valor) +
            " " +
            this.elevarATres(this.corriente17.unit)
          );
        }

      default:
        return "sin secuencia";
    }
  }

  elevarATres(unit = "") {
    const result = unit.replace(/3/g, "\u00B3");

    return result;
  }

  /**
   * Deja dos decimales
   * @param {*} value
   * @returns
   */
  toFixedValue(value = 0) {
    if (this.isMilliUnit(value.toFixed(2))) {
      return value.toFixed(0);
    } else {
      return value.toFixed(2);
    }
  }

  /**
   * Metodo que retorna true si es una unidad de mil
   * @param {*} num
   * @returns
   */
  isMilliUnit(num) {
    return Math.log10(Math.abs(num)) >= 3;
  }
}
